// import createCubeEdges from '../edges/createCubeEdges';
// import spriteRenderBuffer from '../spriteRenderBuffer';

// import Object3D from '../Object3D';
import Renderer from '../Renderer';

// import OPACITIES from '../OPACITIES';

import AABB3 from '../../math/AABB3';
import Vector2 from '../../math/Vector2';
import Vector3 from '../../math/Vector3';
import Vector4 from '../../math/Vector4';
import Matrix4x4 from '../../math/Matrix4x4';

// import AvlTreeList from '../../lists/AvlTreeList';
// import DoublyList  from '../../lists/DoublyList';

// import defaults from '../options/defaults.js';
// import WireframeMesh from '../meshes/WireframeMesh.js';

// import renderer from '../renderer';
import Scene3D from '../../Scene3D';

const DEFAULT_UP = new Vector3(0, 1, 0);

// const OPAQUE       = OPACITIES.OPAQUE;
// // const TRANSPARENT  = OPACITIES.TRANSPARENT;
// const TRANSLUSCENT = OPACITIES.TRANSLUSCENT;

// let viewCount = 0;

// class ObjectInView {
// 	object: any;
// 	visible: boolean;

// 	constructor (object) {
// 		this.object = object;
// 		this.visible = true;
// 	}
// }

// class TransluscentObjectInView {
// 	object: any;
// 	distanceToView: number;
// 	visible: boolean;
// 	_viewListReference: any;

// 	constructor (object, distanceToView) {
// 		this.object = object;
// 		this.distanceToView = distanceToView;
// 		this.visible = true;
// 		this._viewListReference = null;
// 	}
// }

// const aabbWireframe = new WireframeMesh(createCubeEdges(0.5, 0.5, 0.5, 1));
// const aabbProgramData = {
// 	// Necessary properties
// 	binder: null,
// 	fragmentShaderId: 'aabb',
// 	vertexShaderId: 'aabb',
// 	fragmentShader: require('../shaders/fragment/aabb.frag'),
// 	vertexShader: require('../shaders/vertex/aabb.vert'),
// 	uniformIds: ['uMMatrix', 'uVPMatrix', 'uColor'],
// 	attributeIds: ['aVertexPosition']
// };

// function renderObjectAABB (view, sceneObject) {
// // function renderObjectAABB(sceneObject, view, depth) {
// 	var bounds = sceneObject.bounds;

// 	// Rendering aabb bounds
// 	var x0 = bounds[0];
// 	var x1 = bounds[1];
// 	var y0 = bounds[2];
// 	var y1 = bounds[3];
// 	var z0 = bounds[4];
// 	var z1 = bounds[5];

// 	var gl = renderer.gl;

// 	// Constructing aabb transformation matrix
// 	var mMatrix = new Matrix4x4().setToIdentity()
// 		.translate(new Vector3(x0, y0, z0))
// 		.scale(new Vector3(x1 - x0, y1 - y0, z1 - z0));
// 	gl.uniformMatrix4fv(aabbProgramData.uMMatrix, false, mMatrix.getMatrixArray());

// 	// gl.lineWidth(10 / (1 + 0.2 * depth));
// 	var color = defaults.material.color;
// 	gl.uniform3f(aabbProgramData.uColor,
// 		color.r,
// 		color.g,
// 		color.b
// 	);

// 	aabbWireframe._render(aabbProgramData);
// }

export default abstract class Camera extends AABB3 {
	_near: number;
	_far: number;

	bounds: Array<number>;

	// Camera orientation
	forward: Vector3;
	upward: Vector3;
	rightward: Vector3;

	position: Vector3;
	focusPoint: Vector3;

	_viewMatrix: Matrix4x4;
	_projectionMatrix: Matrix4x4;

	_viewProjectionMatrix: Matrix4x4;
	_inverseViewProjectionMatrix: Matrix4x4;

	_aspectViewProjectionMatrix: Matrix4x4;
	_inverseAspectViewProjectionMatrix: Matrix4x4;

	_planes: Array<Vector4>;

	// _viewId: number;
	// _transluscentObjects: AvlTreeList;
	// _opaqueObjects: DoublyList;
	// _transparentObjects: DoublyList;

	constructor (near: number = 0.1, far: number = 1000) {
		// Camera is an AABB containing a frustum
		super(new Float32Array([Infinity, -Infinity, Infinity, -Infinity, Infinity, -Infinity]));

		this._near = near;
		this._far  = far;

		this.bounds = [0, 0, 0, 0, 0, 0];

		// Camera orientation
		this.forward   = new Vector3(0, 0, -1);
		this.upward    = new Vector3(0, 1, 0);
		this.rightward = new Vector3(1, 0, 0);

		this.position   = new Vector3(0, 0, 0);
		this.focusPoint = new Vector3(0, 0, -1);

		this._viewMatrix       = new Matrix4x4();
		this._projectionMatrix = new Matrix4x4();

		this._viewProjectionMatrix        = new Matrix4x4();
		this._inverseViewProjectionMatrix = new Matrix4x4();

		this._aspectViewProjectionMatrix        = new Matrix4x4();
		this._inverseAspectViewProjectionMatrix = new Matrix4x4();

		// Frustum planes
		this._planes = new Array(6);
		this._planes[0] = new Vector4(0, 0, 0, 0); // left
		this._planes[1] = new Vector4(0, 0, 0, 0); // right
		this._planes[2] = new Vector4(0, 0, 0, 0); // bottom
		this._planes[3] = new Vector4(0, 0, 0, 0); // top
		this._planes[4] = new Vector4(0, 0, 0, 0); // near
		this._planes[5] = new Vector4(0, 0, 0, 0); // far

		// this._viewId = viewCount++;
		// this._transluscentObjects = new AvlTreeList(function (a, b) {
		// 	// Transluscent elements are ordered by distance to camera
		// 	return b.distanceToView - a.distanceToView;
		// }, '_viewListReference');

		// this._opaqueObjects = new DoublyList();
		// this._transparentObjects = new DoublyList();

		// AABB Rendering program - for debug purpose
		// Making sure the aabb rendering program has been built
		// if (aabbProgramData.binder === null) {
		// 	aabbProgramData.lastAttributeIndex = aabbProgramData.attributeIds.length - 1;
		// 	renderer._buildProgram(aabbProgramData);
		// }
	}

	set near (near: number) {
		this._near = near;
		this._setProjection();
	}

	get near () {
		return this._near;
	}

	set far (far: number) {
		this._far = far;
		this._setProjection();
	}

	get far () {
		return this._far;
	}

	abstract getHeight (distance?: number): number

	_setProjection () {}

	getViewProjectionMatrix () {
		this._viewMatrix.setView(this.position, this.forward, this.upward, this.rightward);
		this._viewProjectionMatrix.set(this._projectionMatrix).multiply(this._viewMatrix);
		return this._viewProjectionMatrix;
	}

	getInverseViewMatrix () {
		this._inverseViewProjectionMatrix.set(this.getViewProjectionMatrix()).invert();
		return this._inverseViewProjectionMatrix;
	}

	getInverseAspectViewMatrix () {
		this._inverseAspectViewProjectionMatrix.set(this._aspectViewProjectionMatrix).invert();
		return this._inverseAspectViewProjectionMatrix;
	}

	setPosition (position: Vector3) {
		this.position.setVector3(position);
		this.lookAt(this.focusPoint, this.upward);
	}

	lookAt (point: Vector3, up = DEFAULT_UP) {
		// Computing camera orientation
		this.focusPoint = point;

		// Computing forward direction
		this.forward.set(point.x - this.position.x, point.y - this.position.y, point.z - this.position.z).normalize();

		// Making sure the up axis is compatible with the forward direction
		var fy = Math.abs(this.forward.y);
		if (1 - 1e-5 < fy && fy < 1 + 1e-5 && 1 - 1e-5 < up.y && up.y < 1 + 1e-5) {
			// Forward is upward so upward will be forward
			up = new Vector3(0, 0, 1);
		}

		// Computing rightward direction
		this.rightward = this.forward.cross(up).normalize();

		// Computing upward direction
		this.upward = this.rightward.cross(this.forward).normalize();
	}

	rotate (angle: number, axis: Vector3) {
		// TODO: optimize this method
		var rotationMatrix = new Matrix4x4().setToIdentity().rotate(angle, axis);

		this.forward   = rotationMatrix.multiplyVector3(this.forward);
		this.upward    = rotationMatrix.multiplyVector3(this.upward);
		this.rightward = rotationMatrix.multiplyVector3(this.rightward);

		var distance = this.focusPoint.distance(this.position);
		this.position.setVector3(this.forward).multiplyScalar(-distance).add(this.focusPoint);
	}

	getDirectionToFocusPoint () {
		return this.focusPoint.subtraction(this.position);
	}

	// _sortObject (view, sceneObject) {
	// 	var viewId = view._viewId;
	// 	var objectInView = sceneObject._views[viewId];
	// 	if (sceneObject.opacity === TRANSLUSCENT) {
	// 		// Updating position in the view for later rendering
	// 		var distance = sceneObject.position.distance(view.position);
	// 		if (objectInView) {
	// 			// Object was already visible, updating rendering order
	// 			// In O(1) in average (worst case in O(n))
	// 			objectInView.visible = true;
	// 			objectInView.distanceToView = distance;
	// 			view._transluscentObjects.reposition(objectInView._viewListReference);
	// 		} else {
	// 			// Object was not visible
	// 			// creating wrapper and adding to list of transluscent objects to render
	// 			// In O(log(n))
	// 			objectInView = new TransluscentObjectInView(sceneObject, distance);
	// 			objectInView._viewListReference = view._transluscentObjects.add(objectInView);
	// 			sceneObject._views[viewId] = objectInView; // Saving reference on object
	// 		}
	// 	} else {
	// 		// Object is either opaque or transparent

	// 		if (objectInView) {
	// 			// Object was already visible
	// 			objectInView.visible = true;
	// 		} else {
	// 			// Object was not visible
	// 			// creating wrapper and adding to list of opaque objects to render
	// 			// In O(1)
	// 			objectInView = new ObjectInView(sceneObject); // TODO: make system to avoid creation of this object

	// 			// Opaque and transparent objects are separated for optimization purpose
	// 			if (sceneObject.opacity === OPAQUE) {
	// 				view._opaqueObjects.add(objectInView);
	// 			} else {
	// 				view._transparentObjects.add(objectInView);
	// 			}

	// 			sceneObject._views[viewId] = objectInView; // Saving reference on object
	// 		}
	// 	}
	// }

	render (renderer: Renderer, scene: Scene3D) {
		const displayLists = scene.displayLists;

		const directionalLight = scene.directionalLight;
		const ambientLightColor = scene.ambientLight.light;
		const lightDirection = directionalLight.direction;
		const directionalLightColor = directionalLight.light;
		const cameraPosition = this.position;
		const viewProjectionMatrix = this._aspectViewProjectionMatrix.getMatrixArray();

		const gl = renderer.gl;

		// TODO: add possibility for more than one light
		// TODO: optimize this method, idea: put shaders, transform, render method and texture set on a property of object
		let renderObject;
		if (directionalLight.castShadow) {
			directionalLight.renderShadowMap(renderer, displayLists, this);
			const shadowMapVPMatrix = directionalLight.shadowMapVPMatrix.getMatrixArray();
			// if (Math.random() < 0.01) console.error('shadowMapVPMatrix', shadowMapVPMatrix) 

			renderObject = function (object: any) {
				const shader = object.shaders.shaded;
				const textureSet = object.textureSet.set;
				const programChanged = renderer.setupProgram(shader, textureSet, null);
				const program = shader.program;
				const uniforms = program.uniforms;
				if (programChanged) {
					gl.uniformMatrix4fv(uniforms.uVPMatrix, false, viewProjectionMatrix);
					gl.uniform3f(uniforms.uCameraPosition, cameraPosition.x, cameraPosition.y, cameraPosition.z);
					gl.uniform3f(uniforms.uAmbientLight, ambientLightColor.r, ambientLightColor.g, ambientLightColor.b);
					gl.uniform3f(uniforms.uDirectionalLight, directionalLightColor.r, directionalLightColor.g, directionalLightColor.b);
					gl.uniform3f(uniforms.uLightDirection, lightDirection.x, lightDirection.y, lightDirection.z);

					gl.uniformMatrix4fv(uniforms.uShadowMapVPMatrix, false, shadowMapVPMatrix);

					const programTextures = program.textures;
					gl.activeTexture(programTextures[programTextures.length - 1]);
					directionalLight.shadowMap.texture.bindTexture(renderer.id, gl);
				}

				const modelMatrix = object.transform.globalTransform.getMatrixArray();
				gl.uniformMatrix4fv(uniforms.uMMatrix, false, modelMatrix);
				object.renderShaded(renderer, program);
			}
		} else {
			renderObject = function (object: any) {
				const shader = object.shaders.default;
				const programChanged = renderer.setupProgram(shader, object.textureSet.set, null);
				const program = shader.program;
				const uniforms = program.uniforms;
				if (programChanged) {
					gl.uniformMatrix4fv(uniforms.uVPMatrix, false, viewProjectionMatrix);
					gl.uniform3f(uniforms.uCameraPosition, cameraPosition.x, cameraPosition.y, cameraPosition.z);
					gl.uniform3f(uniforms.uAmbientLight, ambientLightColor.r, ambientLightColor.g, ambientLightColor.b);
					gl.uniform3f(uniforms.uDirectionalLight, directionalLightColor.r, directionalLightColor.g, directionalLightColor.b);
					gl.uniform3f(uniforms.uLightDirection, lightDirection.x, lightDirection.y, lightDirection.z);
				}
	
				const modelMatrix = object.transform.globalTransform.getMatrixArray();
				gl.uniformMatrix4fv(uniforms.uMMatrix, false, modelMatrix);
				object.renderDefault(renderer, program);
			}
		}

		gl.enable(gl.DEPTH_TEST);

		const opaqueList = displayLists.opaque;
		if (opaqueList.length > 0) {
			gl.depthMask(true);
			gl.enable(gl.CULL_FACE);
			gl.disable(gl.BLEND);
			for (let objectNode = opaqueList.first; objectNode !== null; objectNode = objectNode.next) {
				renderObject(objectNode.object);
			}
		}

		// if (transparentObjects.length > 0) {
		// 	this._renderDisplayList(renderer, this._transparentObjects, ambientLight, directionalLight);
		// }

		const transluscentList = displayLists.transluscent;
		if (transluscentList.length > 0) {
			gl.depthMask(false);
			gl.disable(gl.CULL_FACE);
			gl.enable(gl.BLEND);
			gl.blendFunc(gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
			// TODO: reorder transluscent objects
			for (let objectNode = transluscentList.first; objectNode !== null; objectNode = objectNode.next) {
				renderObject(objectNode.object);
			}
		}
	}

	// _renderAABB (displayList) {
	// 	renderer._useProgram(aabbProgramData);

	// 	var gl = renderer.gl;
	// 	var programData = aabbProgramData;

	// 	if (programData.uVPMatrix) {
	// 		gl.uniformMatrix4fv(programData.uVPMatrix, false, this._aspectViewProjectionMatrix.getMatrixArray());
	// 	}

	// 	displayList.forEachCollidingWithFrustum(this, renderObjectAABB);
	// 	// displayList.forEach(renderObjectAABB, this);
	// 	renderer._resetCurrentProgram();
	// }

	updateView (viewWidth: number, viewHeight: number) {
		// Computing the View/Projection matrix
		// if (log && Math.random() < 0.1) {
		// 	console.error(this.position, this.forward, this.upward, this.rightward);
		// 	console.error(this._projectionMatrix);
		// 	console.error(this._viewMatrix);
		// 	// console.error('after this.getViewProjectionMatrix()', this.getViewProjectionMatrix()._m.slice())
		// }
		this._aspectViewProjectionMatrix.set(this.getViewProjectionMatrix()).setAspectRatio(viewHeight / viewWidth);
		// if (log && Math.random() < 0.1) console.error('after this._aspectViewProjectionMatrix', this._aspectViewProjectionMatrix._m.slice())
		// Updating equation of the planes of the frustum
		this._updateFrustumPlanes();
		// Updating bounding box of the frustum
		this.updateBounds(viewWidth, viewHeight);
	}

	abstract updateBounds (viewWidth: number, viewHeight: number): void

	_updateFrustumPlanes () {
		var m = this._aspectViewProjectionMatrix.getMatrixArray();

		var m11 = m[0];
		var m21 = m[1];
		var m31 = m[2];
		var m41 = m[3];

		var m12 = m[4];
		var m22 = m[5];
		var m32 = m[6];
		var m42 = m[7];

		var m13 = m[8];
		var m23 = m[9];
		var m33 = m[10];
		var m43 = m[11];

		var m14 = m[12];
		var m24 = m[13];
		var m34 = m[14];
		var m44 = m[15];

		this._planes[0].set(m41 + m11, m42 + m12, m43 + m13, m44 + m14).normalizePlane();
		this._planes[1].set(m41 - m11, m42 - m12, m43 - m13, m44 - m14).normalizePlane();
		this._planes[2].set(m41 + m21, m42 + m22, m43 + m23, m44 + m24).normalizePlane();
		this._planes[3].set(m41 - m21, m42 - m22, m43 - m23, m44 - m24).normalizePlane();
		this._planes[4].set(m41 + m31, m42 + m32, m43 + m33, m44 + m34).normalizePlane();
		this._planes[5].set(m41 - m31, m42 - m32, m43 - m33, m44 - m34).normalizePlane();
	}
}
